import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, Outlet } from "react-router-dom";

// css
import styles from "./Auth.module.scss";

// img
import logo from "../../Assets/images/logo.png";
import authbg from "../../Assets/images/authbg.png";
import g1 from "../../Assets/images/bub.png";

const AuthLayout = () => {
  return (
    <>
      <section
        className={`${styles.authLayout} authLayout position-relative py-3 d-flex align-items-center justify-content-center flex-column`}
        style={{
          zIndex: "9",
          backgroundImage: `url(${authbg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100vh",
        }}
      >
        <Container className="">
          <Row className="justify-content-center">
            <Col lg="5" md="6" sm="8" className="my-2 py-4">
              <div
                className={`${styles.formWrpper} formWrpper position-relative bg-white px-3 py-4`}
              >
                <div className="logo text-center pb-lg-5 pb-4">
                  <img
                    src={logo}
                    alt=""
                    className="img-fluid object-fit-contain"
                    style={{ width: 120 }}
                  />
                </div>
                <Outlet />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AuthLayout;
